import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Sections.css';

gsap.registerPlugin(ScrollTrigger);

const items = [
  {
    name: 'Zack',
    text: 'Tengkiu ah.. sbb aku dah berhajya buat 2k usd. Thanks Buku TLP yang kau ajarkan, kalau takda benda ni aku pun tak tau nak trade mcm mna.',
    img: '/reviews/zack.jpg',
  },
  {
    name: 'Maria Cust',
    text: 'Acik mula-mula tak faham jugak pasal ape yang susah... tapi alhamdulillah rezeki acik jumpa buku yang betul. Tajuk advance pun acik senang untuk faham. Alhamdulillah terima kasih yee dik.',
    img: '/reviews/maria.jpg',
  },
  {
    name: 'Wan Banggali',
    text: 'Memang terbaik doh buku tu.. Aku trade real follow buku tu hari-hari dapat lah 50-100 usd. Profit: 131.09 dari deposit 100.',
    img: '/reviews/wan.jpg',
  },
  {
    name: 'Tuan Abdullah',
    text: 'Belajar Teknik Trendline sahaja terus yakin untuk depo besar dan Consistent.',
    img: null,
  },
  {
    name: 'Shahira',
    text: 'Selalu ikut signal orang, sekarang dah pandai marking zone sendiri dan entry sendiri dengan yakin.',
    img: null,
  },
  {
    name: 'Asral',
    text: 'Ingat nak tambah ilmu je tapi, lepas baca pandai kawal entry & risk hingga profit lebih jangkaan.',
    img: null,
  },
];

export default function TestimonialSection() {
  const ref = useRef();
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo('.testi-head', { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1, ease: 'power4.out', scrollTrigger: { trigger: ref.current, start: 'top 65%' } });
      document.querySelectorAll('.testi-card').forEach((card, i) => {
        gsap.fromTo(card, { opacity: 0, y: 40, scale: 0.96 },
          { opacity: 1, y: 0, scale: 1, duration: 0.9, delay: i * 0.1, ease: 'power4.out',
            scrollTrigger: { trigger: card, start: 'top 88%' } });
      });
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <section className="sec testi" ref={ref}>
      <div className="container">
        <div className="testi-head">
          <span className="pill">FEEDBACK PREMIUM OLEH PEMBACA</span>
          <h2>Bukti sebenar dari <span className="gold-grad">trader TLP</span></h2>
        </div>
        <div className="testi-grid">
          {items.map((t, i) => (
            <div className="testi-card" key={i}>
              {t.img && (
                <img
                  className="testi-img"
                  src={t.img}
                  alt={`Review dari ${t.name}`}
                  loading="lazy"
                />
              )}
              <div className="testi-stars">{'★★★★★'}</div>
              <p>"{t.text}"</p>
              <div className="testi-author">
                <div className="testi-av">{t.name[0]}</div>
                <strong>{t.name}</strong>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
